export default __webpack_public_path__ + "static/media/ni2-splash-screen.eaf01f8e.png";